// extracted by mini-css-extract-plugin
module.exports = {"PieChartWrapper":"PieChart_PieChartWrapper__2IQsx","PieChart":"PieChart_PieChart__1sP19"};